exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whiteboard-item-icon {\n  display: inline-block;\n  overflow: hidden;\n  width: 24px;\n  height: 24px;\n  fill: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js!./src/components/Icon/index.less
// module id = 16
// module chunks = 0